export default __webpack_public_path__ + "static/media/renewal.cf34efe9.svg";